export default __webpack_public_path__ + "static/media/org-event-attendees.5557ddbb.png";